import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=449eb04d&"
import script from "./PropertyPanel.vue?vue&type=script&lang=ts&"
export * from "./PropertyPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports